const stateRoot = (state) => state.history_sessions;

export const getIsSessionExpanded = (state, sessionId) => stateRoot(state)[sessionId];

export const getUpdatedTime = (state) => stateRoot(state).updated;
